import axios from 'axios';

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

let cachedGeoLocation = null;

/**
 * Fetch user's geolocation data
 * @returns {Promise<Object|null>} Geolocation data or null
 */
export const getGeoLocation = async () => {
  if (cachedGeoLocation) {
    return cachedGeoLocation;
  }

  try {
    const response = await axios.get(GEOLOCATION_API, {
      headers: {
        'accept': 'text/plain'
      }
    });
    
    if (response.data.isSuccess) {
      cachedGeoLocation = response.data;
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching geolocation:', error);
    return null;
  }
};

/**
 * Submit lead form data
 * @param {Object} data - Form data including name, email, phone, etc.
 * @param {Object} geoLocation - Geolocation data from getGeoLocation
 * @param {string} packageTitle - Selected package title (optional)
 * @param {number} packageAmount - Selected package amount (optional)
 * @returns {Promise<Object>} Response object with success status, data, and statusCode
 */
export const submitLead = async (data, geoLocation = null, packageTitle = '', packageAmount = 0) => {
  try {
    // Prepare payload
    const payload = {
      name: data.name,
      email: data.email,
      countryDialCode: parseInt(data.countryCode) || 1,
      country: data.country || 'US',
      phoneNumber: data.phoneNumber.replace(/\D/g, ''), // Only numeric
      ipAddress: geoLocation?.data?.ipAddress || '',
      description: data.description || '',
      pageUrl: window.location.href,
      city: geoLocation?.data?.cityName || '',
      state: geoLocation?.data?.regionName || '',
      geoLocation: geoLocation ? JSON.stringify(geoLocation) : '',
      packageTitle: packageTitle,
      packageAmount: packageAmount
    };

    const response = await axios.post(LEAD_API, payload);
    
    // Handle 200 success response
    if (response.data.statusCode === 200 && response.data.isSuccess) {
      return {
        success: true,
        data: response.data.data,
        statusCode: 200,
        customerId: response.data.data.customerId
      };
    }
    
    return {
      success: false,
      message: response.data.errorMessage || 'Something went wrong',
      statusCode: response.data.statusCode
    };
    
  } catch (error) {
    if (error.response) {
      const responseData = error.response.data;
      const statusCode = responseData.statusCode || error.response.status;
      
      // Handle 401 Unauthorized
      if (statusCode === 401) {
        return {
          success: false,
          message: responseData.message || 'Unauthorized access',
          statusCode: 401
        };
      }
      
      // Handle 400 Bad Request
      if (statusCode === 400) {
        return {
          success: false,
          message: responseData.errorMessage || responseData.data?.message || 'Invalid data',
          statusCode: 400
        };
      }
      
      return {
        success: false,
        message: responseData.errorMessage || responseData.message || 'Request failed',
        statusCode: statusCode
      };
    }
    
    return {
      success: false,
      message: 'Network error. Please check your connection and try again.',
      statusCode: 0
    };
  }
};